module.exports = __webpack_public_path__ + "static/media/undraw_onboarding_o8mv.37cf73da.svg";